import { render } from "./tagsView.vue?vue&type=template&id=ee273a00&scoped=true&ts=true"
import script from "./tagsView.vue?vue&type=script&lang=ts"
export * from "./tagsView.vue?vue&type=script&lang=ts"

import "./tagsView.vue?vue&type=style&index=0&id=ee273a00&lang=scss&scoped=true"

import exportComponent from "E:\\bjft\\bjft-merchant-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee273a00"]])

export default __exports__